const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

function canUseWindow() {
  return typeof window !== 'undefined';
}

function isLocalHostname(hostname: string) {
  return LOCAL_HOSTNAMES.has(hostname);
}

function normalizeConfiguredUrl(value: string | undefined, fallbackPath: string) {
  if (!value) return fallbackPath;

  if (!canUseWindow()) return value;

  const trimmed = value.trim();
  if (!trimmed) return fallbackPath;

  if (trimmed.startsWith('/')) return trimmed;

  try {
    const configuredUrl = new URL(trimmed);
    const currentUrl = new URL(window.location.origin);
    const configuredIsLocal = isLocalHostname(configuredUrl.hostname);
    const currentIsLocal = isLocalHostname(currentUrl.hostname);

    // Browser preview over tunnel/HTTPS should not call tunnel-host:4000 directly.
    // Keep API calls same-origin (Vite proxy) so backend stays local.
    if (configuredIsLocal && !currentIsLocal) {
      return fallbackPath;
    }

    return configuredUrl.toString();
  } catch {
    return trimmed;
  }
}

export function getApiBaseUrl() {
  if (!canUseWindow()) return import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

  return normalizeConfiguredUrl(import.meta.env.VITE_API_URL, '/api');
}

export function getWsUrl() {
  if (!canUseWindow()) return import.meta.env.VITE_WS_URL || 'ws://localhost:4000/ws';

  return normalizeConfiguredUrl(import.meta.env.VITE_WS_URL, '/ws');
}
